
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cog-icon cog-i-ex",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","focusable":"false","class":"cog-icon cog-i-ex"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('path',{attrs:{"d":"M4.2 4.2l9.6 9.6M13.8 4.2l-9.6 9.6"}})])])
          )
        }
      }
    